import * as React from "react"
import { useSelector } from "react-redux"
import { AppState } from "../../../store/types"

export function ResponseBlock() {
  const { parkingAvailabilityModel, chartData } = useSelector(
    (state: AppState) => state.devDocs
  )

  return (
    <div className="text-left">
      <p>Availability Response:</p>
      <pre>
        {parkingAvailabilityModel !== undefined &&
          JSON.stringify(parkingAvailabilityModel, null, "\t")}
      </pre>
      <p>Forecast Response:</p>
      <pre>
        {chartData !== undefined &&
          JSON.stringify(chartData, null, "\t")}
      </pre>
    </div>
  )
}
